<template>
  <div class="nc-popover-anchor" ref="anchor">
    <slot name="trigger" :open="open" />
    <Teleport to="body">
      <div v-if="isOpen" class="nc-popover-backdrop" @click="close" />
      <div
        v-if="isOpen"
        class="nc-popover"
        ref="popover"
        :style="popoverStyle"
      >
        <div class="nc-popover__content">
          <slot :close="close" />
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'NcPopover',
  props: {
    width: { type: String, default: '200px' },
  },
  data() {
    return {
      isOpen: false,
      popoverStyle: {},
    };
  },
  methods: {
    open(event) {
      this.isOpen = true;
      this.$nextTick(() => {
        this.positionPopover(event);
      });
    },
    close() {
      this.isOpen = false;
    },
    positionPopover(event) {
      const anchor = event?.target || this.$refs.anchor;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      this.popoverStyle = {
        position: 'fixed',
        top: rect.bottom + 4 + 'px',
        right: (window.innerWidth - rect.right) + 'px',
        width: this.width,
        zIndex: 10001,
      };
    },
  },
};
</script>

<style scoped>
.nc-popover-anchor { display: inline-flex; }
.nc-popover-backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 10000;
}
.nc-popover {
  background: var(--nc-bg-card);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  animation: nc-popover-in 0.15s ease;
}
.nc-popover__content { padding: 6px 0; }
@keyframes nc-popover-in {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
